<template>
  <div class="data_brain_wrap">

    <el-row class="card_wrap" type="flex">
      <div style="height: 6%; display: flex; align-items: center">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 3ch; font-weight: 700; color: #111">
          <el-breadcrumb-item :to="{ path: '/' }">
            首页需求发布
          </el-breadcrumb-item>
          <el-breadcrumb-item>供应</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="
          display: flex;
          width: 100%;
          height: 86%;
          align-items: center;
          justify-content: space-between;
        ">
        <div style="
            width: 60%;
            height: 100%;
            background-color: #f4f6f5;
            position: relative;
          ">
          <div class="page-content">
            <!-- <div class="fenlei">
              <div
                v-for="(item, index) in articleType"
                :key="index"
                class="fenleilist">
                {{ item.name }}
              </div>
            </div> -->

            <div style="padding: 12px; display: flex; flex-direction: column">
              <el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules">
                <el-form-item label="需求标题" prop="title">
                  <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="需求类型" prop="type">
                  <el-select v-model="form.type" placeholder="请选择需求类型">
                    <el-option :label="item.name" :value="item.id" v-for="(item, index) in zbtype"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="需求图片" prop="pic">
                  <!-- <el-input v-model="form.pic"></el-input> -->
                  <!-- <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload> -->
                  <!-- <div @click="tomsg">123</div> -->

                  <!-- 选择文件的输入框 -->
                  <!-- <input
                    type="file"
                    @change="handleFileChange"
                    accept="image/*"
                    v-if="!hasUploaded" 
					/> -->
                  <label class="custom-upload" v-if="!hasUploaded">
                    <input type="file" @change="handleFileChange" accept="image/*" style="display: none" />
                    <span class="upload-text">点击选择图片</span>
                  </label>
                  <img v-if="previewUrl" :src="previewUrl" alt="Uploaded Image" style="max-width: 6vw" />
                </el-form-item>

                <el-form-item label="需求描述" prop="desc">
                  <el-input type="textarea" v-model="form.desc"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button type="primary" @click="onSubmit">发布</el-button>
                  <el-button>分享</el-button>
                </el-form-item> -->
              </el-form>
            </div>
          </div>
        </div>
        <div class="card">
          <div style="height: 30%; width: 100%">
            <el-carousel indicator-position="none">
              <el-carousel-item v-for="(item2, index2) in ad2" :key="index2">
                <!-- <h3 class="small">{{ item }}</h3> -->
                <a :href="item2.link">
                  <img :src="item2.pic" alt="" style="width: 100%; height: 100%" />
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div style="height: 30%; width: 100%">
            <el-carousel indicator-position="none">
              <el-carousel-item v-for="(item3, index3) in ad3" :key="index3">
                <!-- <h3 class="small">{{ item }}</h3> -->
                <a :href="item3.link">
                  <img :src="item3.pic" alt="" style="width: 100%; height: 100%" />
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div style="height: 30%; width: 100%">
            <el-carousel indicator-position="none">
              <el-carousel-item v-for="(item4, index4) in ad4" :key="index4">
                <!-- <h3 class="small">{{ item }}</h3> -->
                <a :href="item4.link">
                  <img :src="item4.pic" alt="" style="width: 100%; height: 100%" />
                </a>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div style="
          height: 8%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <el-button type="primary" @click="onSubmit('form')"
          style="width: 8vw; height: 2vw; font-weight: 600; font-size: 2ch">
          发布
        </el-button>
        <!-- <el-button type="primary" @click="onSubmit">分享</el-button> -->
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getArticle,
  getCardInfo,
  getUserInfo,
  postZb,
  ZbType,
  AdList,
  // ToImg,
} from "@/api/user.js";



export default {

  data() {
    return {
      currentPage: 1,
      pageSize: 4, // 每页显示的卡片数量
      cardlist: [],
      // 所有数据
      allData: [],
      articleType: [],
      content: "",
      cardinfo: [],
      userInfo: [],
      cid: 0,
      zbtype: [
        // {
        //   "value": 1,
        //   "label": "找产品"
        // },
        // {
        //   "value": 2,
        //   "label": "找客户"
        // },
        // {
        //   "value": 3,
        //   "label": "找项目"
        // },
        // {
        //   "value": 4,
        //   "label": "找投资"
        // },
        // {
        //   "value": 5,
        //   "label": "找居间"
        // },
        // {
        //   "value": 6,
        //   "label": "找人才"
        // },
        // {
        //   "value": 7,
        //   "label": "找猎头"
        // }
      ],
      form: {
        title: "",
        type: "",
        desc: "",
      },
      hasUploaded: false,
      pics: "",
      // 用于预览图片的 URL
      previewUrl: "",
      // 图片的完整路径
      fullImagePath: [],
      // 固定的上传路径
      baseUrl: "https://demo.yinaixinxi.com/upload/1/20250305/",
      rules: {
        title: [
          {
            required: true,
            message: "请输入需求标题",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择需求类型",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "请输入需求描述",
            trigger: "blur",
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur",
          },
        ],
      },
      searchlist: [
        { title: "在线教育" },
        { title: "房地产" },
        { title: "钢铁" },
        { title: "新能源汽车" },
        { title: "物流" },
        { title: "小米" },
        { title: "瑞幸咖啡" },
        { title: "医疗器械" },
        { title: "换一批" },
      ],
      joblist: [
        { title: "信息技术" },
        { title: "金融" },
        { title: "医药生物" },
        { title: "电子设备" },
        { title: "文化传媒" },
        { title: "机械设备" },
        { title: "食品饮料" },
        { title: "建筑建材" },
        { title: "基础化工" },
      ],
      tstitle: [
        { title: "深度研究" },
        { title: "非券商报告" },
        { title: "英译中" },
      ],
      jglist: [{ img: "" }],
      ad2: [],
      ad3: [],
      ad4: [],
    };
  },
  computed: {
    isToken() {
      return !!localStorage.getItem("token");
    },
    total() {
      return this.allData.length;
    },
    // 计算当前页面要显示的数据
    currentPageContent() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allData.slice(start, end);
    },
    categoryNames() {
      return this.articleType.reduce((acc, category) => {
        acc[category.id] = category.name;
        return acc;
      }, {});
    },
  },
  created() {
    this.getdata();
  },
  methods: {
    handleFileChange(event) {
      // 获取用户选择的文件
      const file = event.target.files[0];

      if (file) {
        // 拼接完整的图片路径
        this.fullImagePath.push(this.baseUrl + file.name);

        // 创建一个 FileReader 对象
        const reader = new FileReader();

        // 当文件读取完成时触发
        reader.onload = (e) => {
          // 将读取的文件内容赋值给 previewUrl，用于预览
          this.previewUrl = e.target.result;
          console.log(this.previewUrl);
          console.log(this.fullImagePath);
        };

        // 读取文件为 DataURL 格式
        reader.readAsDataURL(file);
        this.hasUploaded = true;
      }
    },
    getdata() {
      const that = this;
      AdList(
        ['RELEASE-AD-2', 'RELEASE-AD-3', 'RELEASE-AD-4']
      ).then((res) => {
        console.log(res);
        that.ad2 =res.data['RELEASE-AD-2'] && res.data['RELEASE-AD-2'].data ? JSON.parse(res.data['RELEASE-AD-2'].data) : [];
        that.ad3 = res.data['RELEASE-AD-3'] && res.data['RELEASE-AD-3'].data ? JSON.parse(res.data['RELEASE-AD-3'].data) : [];
        that.ad4 = res.data['RELEASE-AD-4'] && res.data['RELEASE-AD-4'].data ? JSON.parse(res.data['RELEASE-AD-4'].data) : [];
        // that.ad1 = res.data;
      });
      // getArticle({ cid: that.cid }).then((res) => {
      //   console.log(res);
      //   that.allData = res.data;
      //   that.articleType = res.clist;
      // });
      // getCardInfo().then((res) => {
      //   console.log(res);
      //   that.cardinfo = res.data.info;
      // });
      // getUserInfo().then((res) => {
      //   that.userInfo = res.pagecontent[0].data.userinfo;
      //   that.cardlist = [
      //     ...res.pagecontent[2].data,
      //     ...res.pagecontent[4].data,
      //   ];
      //   console.log(that.cardlist);
      // });
      ZbType({page:1,limit:1000}).then((res) => {
        console.log("ZbType1", res);
        that.zbtype = res.data;
      });


    },
    // tomsg(){
    // 	ToImg({s:'/ApiImageupload/uploadImg/aid/' + app.globalData.aid + '/platform/' + app.globalData.platform +'/session_id/' +app.globalData.session_id+'/sortnum/'+i+'/other_param/'+otherParam}).then((res)=>{
    // 			  console.log('pic',res);
    // 	})
    // },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
    handleNavigate() {
      this.$router.push("/production/1").catch((v) => { });
    },
    onSubmit(form) {
      const that = this;
      if (!that.isToken) {
        console.log('that.isLoggedIn',that.isToken)
        that.$emit("showpop", "open");
        return
      }
      console.log(that.form);
      that.$refs[form].validate((valid) => {
        if (valid) {
          postZb({
            title: that.form.title,
            description: that.form.desc,
            type_id: that.form.type,
            attachments: that.previewUrl,
          }).then((res) => {
            console.log(res);
            that.$refs[form].resetFields();
            (that.previewUrl = ""), (this.hasUploaded = false);
            that.$notify({
              title: "成功",
              message: res.msg,
              type: "success",
            });
          });
          // alert("submit!");
        } else {
          console.log("error submit!!");
          that.$notify.error({
            title: "失败",
            message: "发布失败",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-size: 2ch !important;
  color: #828689 !important;
  font-weight: 600 !important;
  text-align: left !important;
}

.data_brain_wrap {
  padding: 0 0 70px 0;
  background: #fff;

  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 800px;
    border-radius: 8px;
    position: relative;

    @media screen and (max-width: 768px) {
      width: 95%;
    }

    .custom-upload {
      cursor: pointer;
      padding: 8px 16px;
      background: #409eff;
      color: white;
      border-radius: 4px;
    }

    .upload-text:hover {
      opacity: 0.8;
    }

    .card {
      width: 38%;
      height: 100%;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      // padding: 1%;
      justify-content: space-between;

      ::v-deep .el-carousel {
        height: 100%;

        .el-carousel__container {
          height: 100%;
        }
      }

      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 20%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;

        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }

        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;

          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }

        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;

          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }

        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
        }
      }

      .newslist {
        width: 100%;
        height: 14%;
        overflow-y: scroll;
        -ms-overflow-style: none;
        /* IE 和 Edge */
        scrollbar-width: none;
        /* Firefox */
      }

      .scrollable-container::-webkit-scrollbar {
        display: none;
        /* 隐藏滚动条 */
      }

      .newNews {
        width: 100%;
        height: 88%;
        overflow-y: scroll;
        -ms-overflow-style: none;
        /* IE 和 Edge */
        scrollbar-width: none;
        /* Firefox */
      }

      .scrollable-container::-webkit-scrollbar {
        display: none;
        /* 隐藏滚动条 */
      }
    }

    .page-content {
      width: 100%;
      height: 100%;
      padding: 5px;

      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }

    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }

    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;

      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }

      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none;
        /* IE 和 Edge */
        scrollbar-width: none;
        /* Firefox */
      }

      .scrollable-container::-webkit-scrollbar {
        display: none;
        /* 隐藏滚动条 */
      }
    }

    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }

    .brain_item {
      transition: background-color 1s;
      padding: 30px;

      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;

        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }

      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;

      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(134deg,
            #0649b8 1%,
            #0a7fd7 41%,
            #03d2c5 99%);
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }

      &:hover .item_bg {
        opacity: 1;
      }

      &:hover .item_title {
        color: #fff;
      }

      &:hover .item_desc {
        color: #fff;
      }

      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }

      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;

        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }

      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;

        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
